module.exports = __webpack_public_path__ + "files/e28023f595db9cc93940c9666ddfa871.png";